import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { MatterFile } from '@models/matter-file';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface MatterFilesParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterFilesRepoService extends Repo<
	MatterFile,
	MatterFilesParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	GetCollectionPath(pathParam: MatterFilesParams): string {
		return CollectionPaths.business_matter_files(
			this.businessId,
			pathParam.matterId,
		);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
